import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.TEAMS}-general`,
	PARAMETERS: `${RouteNames.TEAMS}-parameters`,
	SUPERVISORS: `${RouteNames.TEAMS}-supervisors`,
	AGENTS: `${RouteNames.TEAMS}-agents`,
	HOOKS: `${RouteNames.TEAMS}-hooks`,
	FLOWS: `${RouteNames.TEAMS}-flows`,
	PERMISSIONS: `${RouteNames.TEAMS}-permissions`,
});
